import api from '@/api/API';
import { AgencySummaryFilters, QueryResult } from '@/types';

export default {
  findSummary(id: string, filters: AgencySummaryFilters): Promise<QueryResult> {
    return api
      .get(`agencies/${id}/summary`, {
        params: filters,
      })
      .then(response => response.data);
  },
};
